@use "@fukuri-admins/ui/layout" as *;

.form {
  width: 564px;
}

.selectOption {
  display: flex;
  @include typography('Jp/14_W3');

  &__name {
    color: text('High');
  }

  &__code {
    color: text('Low');
  }
}
